import React from "react"
import {connect} from "react-redux";
import PropTypes from "prop-types"
import BrowseView from "../../browse/BrowseView";
import {bindActionCreators} from "redux";
import * as SiteActions from "../../reducers/site"
import {Row, Col, Button} from "antd"
import {NavLink} from "react-router-dom"
import SiteTable from "./SiteTable";
import PersonTable from "../person/PersonTable";

class SiteView extends React.Component {
    
    static propTypes = {
        sites: PropTypes.array.isRequired,
        persons: PropTypes.array.isRequired,
        getSites: PropTypes.func.isRequired,
        getPersons: PropTypes.func.isRequired,
        fetchingSites: PropTypes.bool.isRequired,
        fetchingPersons: PropTypes.bool.isRequired,
        search: PropTypes.func.isRequired
    };
    
    state = {
        selectedRowKeys: []
    };
    
    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
        this.props.getPersons(selectedRowKeys);
    };
    
    render() {
        const {getSites, sites, persons, fetchingPersons, fetchingSites, search} = this.props;
        const selectedId = this.state.selectedRowKeys[0];
        const disabled = selectedId === undefined;
        const titleBar = <Row>
            <Col span={4}>Site Index</Col>
            <Col span={1} offset={19}>
                <NavLink to={`/site/${selectedId}`}>
                    <Button type='primary' disabled={disabled}>Open</Button>
                </NavLink>
            </Col>
        </Row>;
        return <BrowseView
            masterTitle={titleBar}
            master={<SiteTable dataSource={sites} onSelectChange={this.onSelectChange} loading={fetchingSites} />}
            detailTitle={'Person Details'}
            detail={<PersonTable dataSource={persons} loading={fetchingPersons} compact={false}/>}
            initialQuery={getSites}
            searchableProps={["id","apurebaseId","ct","ut","country","customerId"]}
            searchLogic={search}
            loading={fetchingSites}
        />
    }
}

const mapStateToProps = state => ({
    sites: state.site.sites,
    persons: state.site.persons,
    fetchingSites: state.site.fetchingSites,
    fetchingPersons: state.site.fetchingPersons
});

const mapDispatchToProps = dispatch => ({
    getSites: bindActionCreators(SiteActions, dispatch).getSites,
    getPersons: bindActionCreators(SiteActions, dispatch).getPersons,
    search: bindActionCreators(SiteActions, dispatch).search
});

export default connect(mapStateToProps, mapDispatchToProps)(SiteView)


// WEBPACK FOOTER //
// ./src/js/browse/site/SiteView.js